import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useState } from 'react';
import { BackendFolder } from '@/types/backend';
import FolderTreeView from '@/components/navigation/folder/FolderTreeView';

type MoveFolderDialogProps = {
  folders: BackendFolder[] | undefined;
  selectedFolderId?: number;
  open: boolean;
  onSelect: (item: any) => void;
  onClose: () => void;
};

const MoveFolderDialog: FC<MoveFolderDialogProps> = (props) => {
  const [selectedFolderId, setSelectedFolderId] = useState<number>();

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Select folder to move folder under</DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <FolderTreeView
          folders={props.folders}
          disabledId={props.selectedFolderId}
          foldersOnly
          onFolderClick={(folder) => setSelectedFolderId(folder.folderId)}
          onFolderDoubleClick={(folder) => props.onSelect(folder)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color='primary'>
          Cancel
        </Button>
        <Button onClick={() => props.onSelect(selectedFolderId)} color='primary'>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveFolderDialog;
